import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export default function RequireAuth({ children }) {
    // Authentication is now handled at the DashboardLayout level
    // This component is kept for backwards compatibility
    // and can be used for additional role-based checks in the future
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
}
